import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { Division, DivisionValue } from '../models';

export const divisionActions = createActionGroup({
    source: 'Division',
    events: {
        'Get Division': props<{ id: string }>(),
        'Get Division Success': props<{ payload: Division }>(),
        'Get Division Error': props<{ code: number }>(),

        'Create Division': props<{ value: DivisionValue }>(),
        'Create Division Success': props<{ payload: Division }>(),
        'Create Division Error': props<{ code: number }>(),

        'Update Division': props<{ id: string; value: DivisionValue }>(),
        'Update Division Success': props<{ payload: Division }>(),
        'Update Division Error': props<{ code: number }>(),

        'Delete Division': props<{ id: string }>(),
        'Delete Division Success': props<{ id: string }>(),
        'Delete Division Error': props<{ code: number }>(),

        Clear: emptyProps(),
    },
});
